import React, { useState } from "react";
import "../../styles/__introduction.model.scss";
import doctorImg from "../../assets/images/Doctor-amico 1.png";
import scheduleImg from "../../assets/images/Schedule-amico 1.png";
import trackingImg from "../../assets/images/Online Doctor-pana 1.png";
import moneyImg from "../../assets/images/Manage money-rafiki 1.png";
import Footer from "../../components/footer/Footer";
import { useTranslation } from "react-i18next";

const slides = [
  {
    titleKey: "introduction.slides.orderManagement.title",
    subtitleKey: "introduction.slides.orderManagement.subtitle",
    img: doctorImg,
  },
  {
    titleKey: "introduction.slides.analytics.title",
    subtitleKey: "introduction.slides.analytics.subtitle",
    img: scheduleImg,
  },
  {
    titleKey: "introduction.slides.tracking.title",
    subtitleKey: "introduction.slides.tracking.subtitle",
    img: trackingImg,
  },
  {
    titleKey: "introduction.slides.analytics.title",
    subtitleKey: "introduction.slides.analytics.subtitle",
    img: moneyImg,
  },
];

const Introduction = () => {
  const [current, setCurrent] = useState(0);
  const { t, i18n } = useTranslation();
  return (
    <div className="page-container">
      {/* Modal Section */}
      <div className="modal-overlay">
        <div className="modal-card">
          <h2 className="modal-title">{t(slides[current].titleKey)}</h2>
          <p className="modal-subtitle">{t(slides[current].subtitleKey)}</p>

          <div className="modal-illustration">
            <img src={slides[current].img} alt={t("introduction.slide.alt")} />
          </div>

          <div className="modal-dots">
            {slides.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === current ? "active" : ""}`}
                onClick={() => setCurrent(index)}
              ></span>
            ))}
          </div>

          <div className="modal-actions">
            {current < slides.length - 1 ? (
              <button
                className="modal-btn"
                onClick={() => setCurrent(current + 1)}
              >
                {t("introduction.next")}
              </button>
            ) : (
              <button className="modal-btn">{t("indroduction.finish")}</button>
            )}
          </div>
        </div>
      </div>

      {/* Footer Always at Bottom */}
      <Footer />
    </div>
  );
};

export default Introduction;
